export type Density = 'sparse' | 'balanced' | 'dense';
export type CardStyle = 'outline' | 'flat' | 'soft';
export type MoverLayout = 'split' | 'merged';

export interface TweakSettings {
  accentHue: number;
  accentChroma: number;
  accentLightness: number;
  warmth: number;
  warmthIntensity: number;
  cornerRadius: number;
  density: Density;
  heroChartHeight: number;
  showTickerTape: boolean;
  showSparklines: boolean;
  liveTicks: boolean;
  fontHeading: string;
  headingWeight: number;
  headingTracking: number;
  cardStyle: CardStyle;
  moverLayout: MoverLayout;
}

export const DEFAULT_TWEAKS: TweakSettings = {
  accentHue: 38,
  accentChroma: 0.12,
  accentLightness: 0.55,
  warmth: 55,
  warmthIntensity: 1.8,
  cornerRadius: 20,
  density: 'balanced',
  heroChartHeight: 210,
  showTickerTape: true,
  showSparklines: true,
  liveTicks: true,
  fontHeading: 'Plus Jakarta Sans',
  headingWeight: 700,
  headingTracking: -0.025,
  cardStyle: 'outline',
  moverLayout: 'split',
};
